import React from 'react';
import cls from 'classnames';
import './Tools.scss';

import icon_printer from '../../Resource/image/icons/ic_printer.png';

/**
 *
 * @typedef {{title: string, info: string}} tabInfo
 */

/**
 * @param {object} props
 * @param {tabInfo[]} props.items
 * @param {tabInfo} props.selected
 * @param {(tab: tabInfo) => void} props.onChangeItems
 *
 */


function Tool_printIcon({
  items,
  selected,
  onChangeItems
}) {
  return (
    <div
      className="Tool Tool__printIcon d-flex"
      onClick={() => {
        // window.print();
      }}>
      <div
        style={{
          backgroundImage: `url(${icon_printer})`
        }}
        className="Tool__printIcon__item"
      />
    </div>
  )
}

export default Tool_printIcon;
